import { StateCreator } from 'zustand';
import { ExistingImage, FormImage, FormImagesSlice, NewImage } from './formImagesTypes';
import { removeItem, sortingItems } from './formImagesUtils';

type ImmerStateCreator<T> = StateCreator<
  T,
  [["zustand/immer", never], never],
  [],
  T
>;

export const createImagesSlice: ImmerStateCreator<FormImagesSlice> = (set) => ({ 
    images: [],
    ADD_IMAGES: (images, type) => {  
        if (type === 'new') {
           const newImages = images as NewImage[]
           const newImagesArray: FormImage[] = newImages.map(newImage => ({type: 'new', content: newImage}))
           set((state) => {
               state.images = [...state.images, ...newImagesArray]
           }, false, 'ADD_SELECTED_IMAGES')
        }
        else if (type === 'existing') {
            const existingImages = images as ExistingImage[]
            const existingImagesArray: FormImage[] = existingImages.map(existingImage => ({type: 'existing', content: existingImage}))
            set((state) => {
                state.images = [...state.images, ...existingImagesArray]
            }, false, 'ADD_SELECTED_IMAGES')
        }
    },
    REMOVE_IMAGE: (index: number) => {
        set((state) => {
            const newImages  = removeItem(index, state.images); 
            state.images = newImages
        }, false, 'REMOVE_IMAGE')
    },
    REMOVE_IMAGES: () => {
        set({
            images: []
    }, false, 'REMOVE_IMAGES')
    },
    SORTING_IMAGE: ({source, destination}) => {
        set((state) => {
            const newImages  = sortingItems(source, destination, state.images); 
            state.images = newImages
        }, false, 'SORTING_IMAGE')
    }
});